import { Component, Inject, OnInit } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { hasUserIntegrateIOID, selectAccount, selectUser } from '../../account/store/account.selectors';

@Component({
  selector: 'sidebar',
  template: `
    <div id="sidebar" class="sidebar">
      <div class="sidebar-main">
        <ul class="list-unstyled menu-top">
          <li [ngClass]="{ active: isStateActive('app.account.connections') }">
            <a
              (click)="changeState('app.account.connections', $event)"
              (auxclick)="changeState('app.account.connections', { isMiddleClick: true })"
              matTooltipPosition="right"
              matTooltipClass="hide-arrow"
              [matTooltip]="'sidebar.menu.items.connections' | translate"
            >
              <svg class="icon icons-master-expanded_icon-navmain-connections">
                <use href="#img-sprite_icons-master-expanded_icon-navmain-connections"></use>
              </svg>
              <span class="item-desc">{{ 'sidebar.menu.items.connections' | translate }}</span>
            </a>
          </li>
          <li
            [ngClass]="{ active: isStateActive('app.account.workspaces') || isWorkspacesItemActive }"
            *ngxPermissionsOnly="'workspacesFeature'"
          >
            <a
              (click)="changeState('app.account.workspaces', $event)"
              (auxclick)="changeState('app.account.workspaces', { isMiddleClick: true })"
              matTooltipPosition="right"
              matTooltipClass="hide-arrow"
              [matTooltip]="'sidebar.menu.items.workspaces' | translate"
            >
              <svg class="icon icons-master-expanded_icon-navmain-workspace">
                <use href="#img-sprite_icons-master-expanded_icon-navmain-workspaces"></use>
              </svg>
              <span class="item-desc">{{ 'sidebar.menu.items.workspaces' | translate }}</span>
            </a>
          </li>
          <li [ngClass]="{ active: isStateActive('app.account.packages') }">
            <a
              (click)="changeState('app.account.packages', $event)"
              (auxclick)="changeState('app.account.packages', { isMiddleClick: true })"
              matTooltipPosition="right"
              matTooltipClass="hide-arrow"
              [matTooltip]="'sidebar.menu.items.packages' | translate"
            >
              <svg class="icon icons-master-expanded_icon-navmain-packages">
                <use href="#img-sprite_icons-master-expanded_icon-navmain-packages"></use>
              </svg>
              <span class="item-desc">{{ 'sidebar.menu.items.packages' | translate }}</span>
            </a>
          </li>
          <li [ngClass]="{ active: isStateActive('app.account.jobs') }">
            <a
              (click)="changeState('app.account.jobs', $event)"
              (auxclick)="changeState('app.account.jobs', { isMiddleClick: true })"
              matTooltipPosition="right"
              matTooltipClass="hide-arrow"
              [matTooltip]="'sidebar.menu.items.jobs' | translate"
            >
              <svg class="icon icons-master-expanded_icon-navmain-job">
                <use href="#img-sprite_icons-master-expanded_icon-navmain-job"></use>
              </svg>
              <span class="item-desc">{{ 'sidebar.menu.items.jobs' | translate }}</span>
            </a>
          </li>
          <li [ngClass]="{ active: isStateActive('app.account.clusters') }">
            <a
              (click)="changeState('app.account.clusters', $event)"
              (auxclick)="changeState('app.account.clusters', { isMiddleClick: true })"
              matTooltipPosition="right"
              matTooltipClass="hide-arrow"
              [matTooltip]="'sidebar.menu.items.clusters' | translate"
            >
              <svg class="icon icons-master-expanded_icon-navmain-clusters">
                <use href="#img-sprite_icons-master-expanded_icon-navmain-clusters"></use>
              </svg>
              <span class="item-desc">{{ 'sidebar.menu.items.clusters' | translate }}</span>
            </a>
          </li>
          <li [ngClass]="{ active: isStateActive('app.account.schedules') }">
            <a
              (click)="changeState('app.account.schedules', $event)"
              (auxclick)="changeState('app.account.schedules', { isMiddleClick: true })"
              matTooltipPosition="right"
              matTooltipClass="hide-arrow"
              [matTooltip]="'sidebar.menu.items.schedules' | translate"
            >
              <svg class="icon icons-master-expanded_icon-navmain-schedules">
                <use href="#img-sprite_icons-master-expanded_icon-navmain-schedules"></use>
              </svg>
              <span class="item-desc">{{ 'sidebar.menu.items.schedules' | translate }}</span>
            </a>
          </li>
          <li [ngClass]="{ active: isStateActive('app.account.settings') }">
            <a
              (click)="changeState('app.account.settings', $event)"
              (auxclick)="changeState('app.account.settings', { isMiddleClick: true })"
              matTooltipPosition="right"
              matTooltipClass="hide-arrow"
              [matTooltip]="'sidebar.menu.items.settings' | translate"
            >
              <svg class="icon icons-master-expanded_icon-navmain-settings">
                <use href="#img-sprite_icons-master-expanded_icon-navmain-settings"></use>
              </svg>
              <span class="item-desc">{{ 'sidebar.menu.items.settings' | translate }}</span>
            </a>
          </li>
        </ul>
        <div class="menu-bottom" *ngIf="user$ | async as user">
          <div class="user-name" *ngIf="account$ | async as account">
            <span>{{ user.name }} <span> / </span></span>
            <span>{{ account.name }}</span>
          </div>
          <xp-loader class="user-name-loader" *ngIf="!(account$ | async)"></xp-loader>
          <mat-menu #dropdown="matMenu" yPosition="above" xPosition="after" class="accounts-menu-panel">
            <div mat-menu-item class="accounts-menu-item" [disableRipple]="true">
              <accounts-menu [isVisible]="true"></accounts-menu>
            </div>
          </mat-menu>
          <img
            *ngIf="user.avatar_url"
            class="user-avatar"
            [matMenuTriggerFor]="dropdown"
            [src]="user.avatar_url"
            [alt]="user.name"
          />
          <svg *ngIf="!user.avatar_url" class="user-avatar" [matMenuTriggerFor]="dropdown">
            <use href="#img-sprite_icons-master-expanded_icon-general-avatar"></use>
          </svg>
        </div>
      </div>
      <div class="sidebar-sub" *ngIf="isSubWrapperVisible">
        <div class="sub-menu">
          <strong class="sub-menu-header">{{ 'sidebar.sub-menu.headers.account-settings' | translate }}</strong>
          <ul class="list-unstyled">
            <li [ngClass]="{ active: isStateActive('app.account.settings.account.info') }">
              <a
                (click)="changeState('app.account.settings.account.info', $event)"
                (auxclick)="changeState('app.account.settings.account.info', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.information' | translate }}</a
              >
            </li>
            <li [ngClass]="{ active: isStateActive('app.account.settings.account.plans') }">
              <a
                (click)="changeState('app.account.settings.account.plans', $event)"
                (auxclick)="changeState('app.account.settings.account.plans', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.billing' | translate }}</a
              >
            </li>
            <li [ngClass]="{ active: isStateActive('app.account.settings.account.usage') }">
              <a
                (click)="changeState('app.account.settings.account.usage', $event)"
                (auxclick)="changeState('app.account.settings.account.usage', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.usage' | translate }}</a
              >
            </li>
            <li [ngClass]="{ active: isStateActive('app.account.settings.account.hooks') }">
              <a
                (click)="changeState('app.account.settings.account.hooks', $event)"
                (auxclick)="changeState('app.account.settings.account.hooks', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.hooks' | translate }}</a
              >
            </li>
            <li [ngClass]="{ active: isStateActive('app.account.settings.account.members') }">
              <a
                (click)="changeState('app.account.settings.account.members', $event)"
                (auxclick)="changeState('app.account.settings.account.members', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.members' | translate }}</a
              >
            </li>
          </ul>
          <strong class="sub-menu-header">{{ 'sidebar.sub-menu.headers.your-settings' | translate }}</strong>
          <ul class="list-unstyled">
            <li [ngClass]="{ active: isStateActive('app.account.settings.my.info') }">
              <a
                (click)="changeState('app.account.settings.my.info', $event)"
                (auxclick)="changeState('app.account.settings.my.info', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.personal_information' | translate }}</a
              >
            </li>
            <li
              [ngClass]="{ active: isStateActive('app.account.settings.my.password') }"
              *ngIf="!(hasUserIntegrateIOID$ | async)"
            >
              <a
                (click)="changeState('app.account.settings.my.password', $event)"
                (auxclick)="changeState('app.account.settings.my.password', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.change_password' | translate }}</a
              >
            </li>
            <li
              [ngClass]="{ active: isStateActive('app.account.settings.my.mfa') }"
              *ngIf="!(hasUserIntegrateIOID$ | async)"
            >
              <a
                (click)="changeState('app.account.settings.my.mfa', $event)"
                (auxclick)="changeState('app.account.settings.my.mfa', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.mfa' | translate }}</a
              >
            </li>
            <li [ngClass]="{ active: isStateActive('app.account.settings.my.notifications') }">
              <a
                (click)="changeState('app.account.settings.my.notifications', $event)"
                (auxclick)="changeState('app.account.settings.my.notifications', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.notifications' | translate }}</a
              >
            </li>
            <li [ngClass]="{ active: isStateActive('app.account.settings.my.keys') }">
              <a
                (click)="changeState('app.account.settings.my.keys', $event)"
                (auxclick)="changeState('app.account.settings.my.keys', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.ssh_keys' | translate }}</a
              >
            </li>
            <li [ngClass]="{ active: isStateActive('app.account.settings.my.accounts') }">
              <a
                (click)="changeState('app.account.settings.my.accounts', $event)"
                (auxclick)="changeState('app.account.settings.my.accounts', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.accounts' | translate }}</a
              >
            </li>
          </ul>
          <strong class="sub-menu-header">{{ 'sidebar.sub-menu.headers.developer-settings' | translate }}</strong>
          <ul class="list-unstyled">
            <li [ngClass]="{ active: isStateActive('app.account.settings.developer.tokens') }">
              <a
                (click)="changeState('app.account.settings.developer.tokens', $event)"
                (auxclick)="changeState('app.account.settings.developer.tokens', { isMiddleClick: true })"
                >{{ 'sidebar.sub-menu.items.tokens' | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  `,
})
export class SidebarComponent implements OnInit {
  isSubWrapperVisible = false;
  isWorkspacesItemActive = false;
  user$ = this.store.select(selectUser);
  account$ = this.store.select(selectAccount);
  hasUserIntegrateIOID$ = this.store.select(hasUserIntegrateIOID);

  constructor(@Inject('$rootScope') private $rootScope: any, private store: Store<AppState>) {
    this.$rootScope.$on('$stateChangeSuccess', () => {
      this.setMenuFlags();
    });
  }

  ngOnInit() {
    this.setMenuFlags();
  }

  changeState(stateName: string, event: any): void {
    const openInNewTab = event.metaKey || event.ctrlKey || event.isMiddleClick;
    this.$rootScope.stateGo(stateName, {}, openInNewTab);
  }

  isStateActive(stateName: string): boolean {
    return this.$rootScope.stateIncludes(stateName);
  }

  setMenuFlags() {
    this.isWorkspacesItemActive = this.$rootScope.stateIncludes('app.account.workspaces-item');
    this.isSubWrapperVisible = this.$rootScope.stateIncludes('app.account.settings');
  }
}

((window as any).xplenty as angular.IModule).directive(
  'sidebar',
  downgradeComponent({
    component: SidebarComponent,
  }),
);
